import React, { useEffect } from 'react';
import Header from './Header';

const ImpressumPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#E8F5E0] to-white">
      <Header />
      
      <div className="pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            
            <div className="border-b-2 border-[#1A3A2E] pb-6 mb-8">
              <h1 className="text-4xl font-bold text-[#1A3A2E] mb-2">
                Impressum
              </h1>
              <p className="text-gray-600">Angaben gemäß § 5 TMG</p>
            </div>

            <div className="space-y-8 text-gray-800">
              {/* Unternehmen */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">Verantwortlich</h2>
                <div className="bg-[#E8F5E0] p-6 rounded-lg space-y-2">
                  <p className="text-xl font-bold text-[#1A3A2E]">NOVATUS Energie GmbH</p>
                  <p>Maximiliankorso 60</p>
                  <p>13465 Berlin</p>
                  <p>Deutschland</p>
                </div>
              </section>

              {/* Vertreten durch */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">Vertreten durch</h2>
                <p className="leading-relaxed">
                  <strong>Geschäftsführer:</strong> Dipl.-Verw. Wiss. Christof Schirm
                </p>
              </section>

              {/* Kontakt */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">Kontakt</h2>
                <div className="space-y-2">
                  <p>
                    <strong>Telefon:</strong>{' '}
                    <a href="tel:+493039820570" className="text-[#1A3A2E] hover:underline">
                      +49 (0)30 398205700
                    </a>
                  </p>
                  <p>
                    <strong>E-Mail:</strong>{' '}
                    <a href="mailto:info@novatus-se.com" className="text-[#1A3A2E] hover:underline">
                      info@novatus-se.com
                    </a>
                  </p>
                </div>
              </section>

              {/* Registereintrag */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">Registereintrag</h2>
                <div className="space-y-2">
                  <p><strong>Registergericht:</strong> Amtsgericht Charlottenburg</p>
                  <p><strong>Registernummer:</strong> HRB 222 580</p>
                </div>
              </section>

              {/* Umsatzsteuer-ID */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">Umsatzsteuer-ID</h2>
                <p>
                  <strong>USt-IdNr.:</strong> DE 296 655 515
                </p>
                <p className="text-sm text-gray-600 mt-2">
                  Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz
                </p>
              </section>

              {/* EU-Streitschlichtung */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">EU-Streitschlichtung</h2>
                <p className="leading-relaxed mb-4">
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                  <a 
                    href="https://ec.europa.eu/consumers/odr" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-[#1A3A2E] hover:underline font-semibold"
                  >
                    https://ec.europa.eu/consumers/odr
                  </a>
                </p>
                <p className="leading-relaxed">
                  Unsere E-Mail-Adresse finden Sie oben im Impressum.
                </p>
              </section>

              {/* Verbraucherstreitbeilegung */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
                <p className="leading-relaxed">
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </section>

              {/* Haftung für Inhalte */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">Haftung für Inhalte</h2>
                <p className="leading-relaxed mb-4">
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                </p>
                <p className="leading-relaxed">
                  Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                </p>
              </section>

              {/* Haftung für Links */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">Haftung für Links</h2>
                <p className="leading-relaxed mb-4">
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                </p>
                <p className="leading-relaxed">
                  Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                </p>
              </section>

              {/* Urheberrecht */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">Urheberrecht</h2>
                <p className="leading-relaxed mb-4">
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
                <p className="leading-relaxed">
                  Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                </p>
              </section>

              {/* Links zu weiteren rechtlichen Seiten */}
              <div className="mt-12 pt-8 border-t-2 border-[#1A3A2E]/20">
                <h3 className="text-xl font-bold text-[#1A3A2E] mb-4">Weitere rechtliche Informationen</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <a 
                    href="/datenschutz" 
                    className="block bg-[#E8F5E0] hover:bg-[#1A3A2E] hover:text-white p-6 rounded-lg transition-colors"
                  >
                    <h4 className="font-bold mb-2">Datenschutz</h4>
                    <p className="text-sm">Informationen zum Datenschutz</p>
                  </a>
                  <a 
                    href="/agb" 
                    className="block bg-[#E8F5E0] hover:bg-[#1A3A2E] hover:text-white p-6 rounded-lg transition-colors"
                  >
                    <h4 className="font-bold mb-2">AGB</h4>
                    <p className="text-sm">Allgemeine Geschäftsbedingungen</p>
                  </a>
                  <a 
                    href="/widerruf" 
                    className="block bg-[#E8F5E0] hover:bg-[#1A3A2E] hover:text-white p-6 rounded-lg transition-colors"
                  >
                    <h4 className="font-bold mb-2">Widerruf</h4>
                    <p className="text-sm">Widerrufsbelehrung</p>
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-[#1A3A2E] text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} NOVATUS Energie GmbH • Alle Rechte vorbehalten
          </p>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;
